import * as ga from "../lib/ga";

export const gaCreditsLimit = (serviceName) => {
	ga.event({
		action: `limit_exhausted`,
		params: {
			service: serviceName,
		},
	});
};
